import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';
import { EMPRESA_UTILIZA_PROYECTOS } from "../../../common/types/parametroType";
import auth from '../../../common/utility/auth';

import proyectoService from '../../../service/administracion/proyectoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: [
                { id: -1, nombre: "Seleccionar Estado" },
                { id: 1, nombre: "INICIO" },
                { id: 2, nombre: "EN PROCESO" },
                { id: 3, nombre: "TERMINADO" },
                { id: 4, nombre: "ANULADO" }
            ],
            filter: {
                nombre: '',
                numero: '',
                estado: -1,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    handleClearFilters = () => {
        var filter = {
            nombre: '',
            numero: '',
            estado: -1,
            ...FILTER
        };
        var estados = this.state.estados;
        estados[0] = { id: -1, nombre: "Seleccionar Estado" };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        if(property=='estado'){
            var estados = this.state.estados;
            estados[0] = { id: -1, nombre: "TODOS" };
        }
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await proyectoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Proyecto.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await proyectoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Proyecto.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await proyectoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await proyectoService.eliminar(values);
            else
                response = await proyectoService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEstadoActive = (values, IdProyectoEstado) => {
        values.IdProyectoEstado = IdProyectoEstado;
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            var response = await proyectoService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    /******************** FORM MODAL *****************/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            numero: '',
            fechaInicioStr: global.fetchCurrentDateStr(),
            fechaFinStr: global.fetchCurrentDateStr(),
            costoUnitario: 0
        };
    };

    handleNew = () => {

        var params = auth.user().parametros;
        var empresaProyectos = params.filter((m) => m.abreviatura === EMPRESA_UTILIZA_PROYECTOS)[0].valor === "1" ? true : false;
        if (empresaProyectos) {
            var formValues = this.fetchEmptyFormValues();
            this.setState({ visible: true, formValues });
        } else {

            dialog.info('Opción no disponible en su plan actual! ');

        }

    };


    handleEdit = async (values) => {
        var response = await proyectoService.obtenerPorId(values.id);
        if (response !== undefined)
            this.setState({ visible: true, formValues: response });
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await proyectoService.registrar(values);
            else
                response = await proyectoService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, proyectoService.paginacion);
    }

    render() {
        return (
            <div>
                <Header
                    title="Proyecto"
                    onNew={this.handleNew}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onEstadoActive={this.handleEstadoActive}

                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}